import { render, staticRenderFns } from "./Rl5.vue?vue&type=template&id=2d831948&"
import script from "./Rl5.vue?vue&type=script&lang=js&"
export * from "./Rl5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports